/** Public Android APK served from the Vercel static site.
 *  Note: do NOT put this under /app/ — Vercel SPA entry is /app.html and
 *  /app/* was incorrectly served as index.html.
 */
export const ANDROID_APP_APK_URL = '/downloads/KayiCom.apk';
export const ANDROID_APP_APK_FILENAME = 'KayiCom.apk';
export const APP_VERSION_JSON_URL = '/downloads/app-version.json';

/** True when the storefront is running inside the KayiCom Capacitor Android/iOS shell. */
export const isKayiComNativeApp = () => {
  if (typeof window === 'undefined') return false;
  try {
    const cap = window.Capacitor;
    if (cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform()) {
      return true;
    }
    if (cap && (cap.isNative === true || cap.platform === 'android' || cap.platform === 'ios')) {
      return true;
    }
  } catch {
    // ignore
  }
  const ua = String(navigator.userAgent || '');
  return /KayiComApp|capacitor/i.test(ua);
};
